import i18n from "@/i18n";
import store from "@/store";
import _ from "@/boot/lodash";
import { DataModules } from "@/store/modules/data";
import { HookCodes } from "@/data/enums/hooks";
import { createEventFunc, EventMapType, icon } from "./utils";

const createEventMap: EventMapType = (hookId, payload = {}) => ({
  [hookId]: {
    name: i18n.t(`_hook.${hookId}_name`).toString(),
    event: createEventFunc({
      ...payload,
      path: `_hook.${hookId}`,
      slots: event => [
        ...((payload?.slots && payload.slots(event)) || []),
        {
          slot: "name",
          is: "strong",
          message: _.get(
            event.object,
            "product.name_translated",
            _.get(event.object, "product.name", i18n.t("_.product"))
          )
        }
      ]
    })
  }
});

export default {
  ...createEventMap(HookCodes.CONTRACT_PRODUCT_AUTO_EXPIRE_ON, {
    icon: {
      name: "hourglass-half",
      type: "is-danger"
    }
  }),
  ...createEventMap(HookCodes.CONTRACT_PRODUCT_AUTO_EXPIRE_OFF, {
    icon: {
      name: "power-off",
      type: "is-success"
    }
  }),
  ...createEventMap(HookCodes.CONTRACT_PRODUCT_AWAITING_ACTIVATION),
  ...createEventMap(HookCodes.CONTRACT_PRODUCT_BILLING_CYCLE_CHANGED),
  ...createEventMap(HookCodes.CONTRACT_PRODUCT_CANCELLED, {
    icon: {
      name: "times-circle",
      type: "is-grey"
    }
  }),
  ...createEventMap(HookCodes.CONTRACT_PRODUCT_RENEWED, {
    icon: icon.success
  }),
  ...createEventMap(HookCodes.CONTRACT_PRODUCT_START_INVOICING, {
    icon: {
      name: "play-circle",
      type: "is-success"
    }
  }),
  ...createEventMap(HookCodes.CONTRACT_PRODUCT_SETUP_REQUIRE_CONFIRMATION, {
    icon: {
      name: "exclamation-circle",
      type: "is-warning"
    }
  }),
  ...createEventMap(HookCodes.CONTRACT_PRODUCT_STOP_INVOICING, {
    icon: {
      name: "stop-circle",
      type: "is-warning"
    }
  }),
  ...createEventMap(HookCodes.CONTRACT_PRODUCT_STATUS_UPDATED, {
    slots: event => [
      {
        slot: "status",
        is: "strong",
        message: _.get(event, "object.status.name")
      }
    ]
  }),
  ...createEventMap(HookCodes.CONTRACT_PRODUCT_CREATED, {
    icon: icon.success
  }),
  ...createEventMap(HookCodes.CONTRACT_PRODUCT_ACTIVATED),
  ...createEventMap(HookCodes.CONTRACT_PRODUCT_DUE_DATE_CHANGED),
  ...createEventMap(HookCodes.CONTRACT_PRODUCT_PACKAGE_CHANGED, {
    slots: event => {
      return [
        {
          slot: "orderId",
          is: "strong",
          message: _.get(event, "object.invoice_id"),
          onClick: () => {
            store.dispatch(`data/${DataModules.ORDERS}/openPreviewModal`, {
              props: {
                orderId: _.get(event, "object.invoice_id")
              }
            });
          }
        },
        {
          slot: "name",
          is: "strong",
          message: _.get(
            event.object,
            "product.name_translated",
            _.get(event.object, "product.name")
          )
        }
      ];
    }
  }),
  ...createEventMap(HookCodes.CONTRACT_PRODUCT_PRICE_CHANGED),
  ...createEventMap(HookCodes.CONTRACT_PRODUCT_CLOSED),
  ...createEventMap(HookCodes.CONTRACT_PRODUCT_SUSPENDED, {
    icon: {
      name: "pause-circle",
      type: "is-danger"
    }
  }),
  ...createEventMap(HookCodes.CONTRACT_PRODUCT_UNSUSPENDED),
  ...createEventMap(HookCodes.CONTRACT_PRODUCT_CANCEL_REQUEST_CREATED, {
    icon: icon.success
  }),
  ...createEventMap(HookCodes.CONTRACT_PRODUCT_CANCEL_REQUEST_APPROVED),
  ...createEventMap(HookCodes.CONTRACT_PRODUCT_CANCEL_REQUEST_DELETED_USER, {
    icon: icon.danger
  }),
  ...createEventMap(HookCodes.CONTRACT_PRODUCT_CANCEL_REQUEST_DELETED_CLIENT, {
    icon: icon.danger
  }),
  ...createEventMap(HookCodes.CONTRACT_PRODUCT_COMPANY_ADDRESS_VAT_UPDATED, {
    slots: event => {
      return [
        {
          slot: "price",
          is: "strong",
          message: event?.object?.configuration_total_amount_formatted
        }
      ];
    }
  }),
  ...createEventMap(HookCodes.CONTRACT_PRODUCT_OWNERSHIP_CHANGED, {
    slots: event => {
      return [
        {
          slot: "name",
          is: "strong",
          message: _.get(
            event.object,
            "product.name_translated",
            _.get(event.object, "product.name")
          )
        }
      ];
    }
  }),
  ...createEventMap(HookCodes.CONTRACT_PRODUCT_CURRENCY_CHANGED, {
    slots: event => {
      return [
        {
          slot: "currency",
          is: "strong",
          message: _.get(event, "object.base_currency_code")
        },
        {
          slot: "name",
          is: "strong",
          message: _.get(
            event.object,
            "product.name_translated",
            _.get(event.object, "product.name")
          )
        }
      ];
    }
  })
};
